export const fr: Record<string, string> = {
  app_subtitle: 'Trouvez le prochain jeu de votre liste de souhaits en fonction de votre temps et budget.',
  steam_id_placeholder: 'Entrez votre ID Steam64 (ex: 76561198012345678)',
  fetch_wishlist: 'Récupérer la liste',
  landing_help: 'Votre profil Steam et liste de souhaits doivent être <strong>publics</strong>. Trouvez votre ID Steam64 sur <a href="https://steamid.io" target="_blank" rel="noopener">steamid.io</a>.',
  landing_disclaimer: 'Ceci est un projet créé par un fan, non affilié à <a href="https://store.steampowered.com" target="_blank" rel="noopener">Valve</a>, <a href="https://www.gog.com" target="_blank" rel="noopener">GOG</a> ou <a href="https://howlongtobeat.com" target="_blank" rel="noopener">HowLongToBeat</a>. Les données sont uniquement stockées localement. Code source <a href="https://github.com/t0mg/howlong">sur GitHub</a>.',
  loading_games_enriched: '{count} / {total} jeux traités ({percent}%)',
  loading_throttled_title: 'Steam limite les requêtes',
  loading_waiting: 'Attente {time}...',
  loading_stop: 'Arrêter & Afficher',
  loading_stopping: 'Arrêt et préparation des résultats...',
  loading_fetching_appid: 'Récupération de la liste des AppID...',
  loading_fetching_prices: 'Récupération des prix...',
  loading_fetching_details: 'Récupération des détails...',
  loading_fetching_details_count: 'Récupération des détails pour {count} jeux...',
  loading_enriching: 'Enrichissement avec les données HowLongToBeat...',
  loading_enriching_gog: 'Enrichissement avec les données GOG...',
  error_wishlist_private: 'La liste de souhaits est vide ou privée.',
  error_no_details: 'Impossible de récupérer les détails de vos jeux.',
  error_unexpected: 'Une erreur inattendue est survenue.',
  error_try_again: 'Réessayer',
  dashboard_change_id: '← Changer d\'ID Steam',
  dashboard_lucky: 'J\'ai de la chance',
  dashboard_insights: 'Statistiques',
  dashboard_filter_label: 'Filtre :',
  dashboard_filter_all: 'Toutes les catégories',
  dashboard_sort_label: 'Trier par :',
  dashboard_match_info: 'Données HLTB trouvées pour {found} / {total} jeux',
  dashboard_hltb_warning: '⚠️ Certaines données HLTB sont indisponibles suite à des erreurs serveur. Rechargez la page pour réessayer.',
  lucky_title: 'J\'ai de la chance',
  lucky_desc: 'Vous ne savez pas à quoi jouer ? Laissez le hasard décider.',
  lucky_too_long: 'Plus court',
  lucky_not_in_mood: 'Différent',
  lucky_too_expensive: 'Moins cher',
  lucky_ok: 'Fermer',
  lucky_empty: 'Désolé, plus aucun jeu à suggérer !',
  stats_games: 'Jeux',
  stats_main: 'Histoire Principale',
  stats_main_extra: 'Histoire Principale + Extras',
  stats_completionist: 'Complétionniste',
  stats_value: 'Valeur Totale',
  stats_savings: 'Réductions',
  sort_priority: 'Priorité',
  sort_dateAdded: 'Date d\'ajout',
  sort_name: 'Nom',
  sort_hltbMain: 'Durée (Principale)',
  sort_hltbMainExtra: 'Durée (Principale+)',
  sort_hltbCompletionist: 'Durée (100%)',
  sort_priceFinal: 'Prix',
  sort_discountPercent: 'Réduction',
  settings_title: 'Paramètres',
  settings_desc: 'Gérez vos préférences et données locales.',
  settings_region_label: 'Région Steam',
  settings_region_desc: 'Sélectionnez votre région pour des prix corrects.',
  settings_lang_label: 'Langage',
  settings_lang_desc: 'Sélectionnez votre langage préféré.',
  settings_clear_hltb_label: 'Effacer Données HLTB',
  settings_clear_hltb_desc: 'Supprimer les durées de jeu pour forcer la mise à jour.',
  settings_clear_hltb_btn: 'Effacer HLTB',
  settings_cleared: 'Effacé !',
  settings_clear_steam_label: 'Effacer Données Steam',
  settings_clear_steam_desc: 'Supprimer le cache Steam. Les prix sont récupérés en direct.',
  settings_clear_steam_btn: 'Effacer Steam',
  settings_clear_gog_label: 'Effacer Données GOG',
  settings_clear_gog_desc: 'Supprimer le cache GOG.',
  settings_clear_gog_btn: 'Effacer GOG',
  settings_clear_hidden_label: 'Restaurer les jeux masqués',
  settings_clear_hidden_desc: 'Afficher à nouveau tous les jeux qui étaient précédemment masqués.',
  settings_clear_hidden_btn: 'Restaurer',
  settings_hard_reset_label: 'Réinitialisation',
  settings_hard_reset_desc: 'Effacer tout le cache global de l\'application.',
  settings_hard_reset_btn: 'Réinitialiser',
  settings_hard_reset_confirm: 'Êtes-vous sûr ?',
  settings_close: 'Fermer',
  insights_title: 'Statistiques de la Liste',
  insights_desc: 'Analyse de votre liste de souhaits.',
  insights_avg_price_hr: 'Prix moyen/Hr',
  insights_oldest_entry: 'Plus Ancien Jeu',
  insights_top_genre: 'Top Genre',
  insights_total_story: 'Histoire Principale Totale',
  insights_chart_duration: 'Distribution des durées (Hrs)',
  insights_chart_price: 'Distribution des prix ({currency})',
  insights_chart_genre: 'Genres Populaires',
  insights_chart_year: 'Ajout des jeux par année',
  insights_chart_store: 'Meilleur Prix: Steam vs GOG',
  game_coming_soon: 'Bientôt',
  game_demo: 'Démo',
  game_demo_avail: 'Démo dispo.',
  game_added: 'Ajouté le {date}',
  game_free: 'Gratuit',
  game_unavailable: 'Indisponible',
  game_cached: '(cache)',
  game_price_na: 'Prix N/D',
  game_no_hltb: 'Pas de données HLTB',
  game_hltb_pending: 'Recherche...',
  game_link_steam: 'Steam',
  game_link_hltb: 'HLTB',
  game_link_gog: 'GOG',
  dashboard_filter_hidden: 'Jeux masqués',
  game_link_hide: 'Masquer',
  game_link_unhide: 'Afficher',
  hide_confirm_title: 'Masquer le jeu',
  hide_confirm_desc: 'Êtes-vous sûr de vouloir masquer ce jeu ? Il sera retiré de vos listes mais restera suivi.',
  hide_confirm_btn: 'Masquer',
  hide_cancel_btn: 'Annuler',
};
